export function isFileLink(link: string): boolean {
	const fileExtensions = /\.(pdf|doc|docx|xml|csv|json|zip|rar)$/i;

	return fileExtensions.test(link);
}
